import { useTranslation } from 'react-i18next'

import { ComboBox } from '@reveni-io/reveni-ui'

import { exchangeForOrderStatusOptions } from './constants'

const ExchangeForOrderStatusFilter = ({ value, onChange }) => {
  const { t } = useTranslation()

  return (
    <ComboBox
      fullWidth
      value={value}
      label={t('Estado de pedido de cambio')}
      handleChange={e => onChange(e.target.value)}
      menuItems={exchangeForOrderStatusOptions.map(o => ({ label: t(o.label), value: o.value }))}
    />
  )
}

export default ExchangeForOrderStatusFilter
